import { render, staticRenderFns } from "./ReleasesList.vue?vue&type=template&id=42da299a&scoped=true"
import script from "./ReleasesList.vue?vue&type=script&lang=js"
export * from "./ReleasesList.vue?vue&type=script&lang=js"
import style0 from "./ReleasesList.vue?vue&type=style&index=0&id=42da299a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42da299a",
  null
  
)

export default component.exports